import React, { createContext, useContext, useEffect, useState } from "react";

import PropTypes from "prop-types";

const MixpanelContext = createContext(null);

const MIXPANEL_TOKEN = process.env.GATSBY_MIXPANEL_TOKEN || "a0fa5183fd007853ce3dc635ffd04228";
const MIXPANEL_DOMAIN = "demoday.iterative.vc";

export const MixpanelProvider = ({ children }) => {
	const [client, setClient] = useState(null);

	useEffect(() => {
		let isMounted = true;

		if (typeof window === "undefined") {
			return undefined;
		}

		if (!MIXPANEL_TOKEN) {
			return undefined;
		}

		const isProductionDomain = window.location.hostname === MIXPANEL_DOMAIN;
		if (!isProductionDomain) {
			return undefined;
		}

		const loadMixpanel = async () => {
			try {
				const mixpanelModule = await import("mixpanel-browser");
				const mixpanel = mixpanelModule.default || mixpanelModule;

				if (!isMounted) {
					return;
				}

				mixpanel.init(MIXPANEL_TOKEN, {
					debug: process.env.NODE_ENV === "development",
					track_pageview: false,
					persistence: "localStorage",
				});

				window.analytics = mixpanel;
				setClient(mixpanel);
			} catch {
				// Silently ignore analytics initialization failures
			}
		};

		loadMixpanel();

		return () => {
			isMounted = false;
		};
	}, []);

	return <MixpanelContext.Provider value={client}>{children}</MixpanelContext.Provider>;
};

MixpanelProvider.propTypes = {
	children: PropTypes.node.isRequired,
};

export const useMixpanel = () => useContext(MixpanelContext);

export { MixpanelContext };
